import React, { useEffect } from 'react';
import { useTranslate } from '@pegasus/translation';
import { InformationFilled } from '@lux/icons';
import { BackgroundColor, SupportingColor } from '@lux/tokens';
import { tracker } from '@browsing/tracking';

import { track } from '@client/helpers/tracking';

import { StyledBanner } from './styles';

interface SecurityBannerProps {
    handleVisibilityOnClick: () => void;
    userEmail: string;
}

export const SecurityBanner: React.FC<SecurityBannerProps> = ({
    handleVisibilityOnClick,
    userEmail,
}) => {
    useEffect(() => {
        track('compromised_pwd_banner_view');
    }, []);

    const onCloseBanner = () => {
        track('compromised_pwd_banner_close');
        tracker.track('GA4-EEC-select_content', {
            event_name: 'select_content',
            select_content: {
                element: 'compromised_password_banner',
                content_type: 'close',
                content_id: null,
            },
        });
        handleVisibilityOnClick();
    };

    const onLinkClick = () => {
        track('compromised_pwd_banner_click');

        tracker.track('GA4-EEC-select_content', {
            event_name: 'select_content',
            select_content: {
                element: 'compromised_password_banner',
                content_type: 'click',
                content_id: null,
            },
        });

        handleVisibilityOnClick();
        const uspHint = new URLSearchParams(`login_hint=${window.btoa(userEmail)}`);

        window.location.assign(
            `/sso/login?premise=lounge&view=forgot-password&login_hint=${uspHint.get(
                'login_hint',
            )}&target=/event?compromisedbanner`,
        );
    };

    const translate = useTranslate('securityBanner');

    return (
        <StyledBanner
            text={translate('text')}
            linkText={translate('linkText')}
            onCloseBanner={onCloseBanner}
            color={BackgroundColor.info}
            icon={<InformationFilled color={SupportingColor.info} />}
            onLinkClick={onLinkClick}
        />
    );
};
